// React
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect as reduxConnect } from 'react-redux'

// Components
import BPeriod from '../../blocks/Period'
import Icon from 'ui/components/Icon'

// Libraries
import { withTranslation } from 'shared/utils/withTranslation'

// Shared
import Format from 'shared/utils/format'
import ClientActions from 'store/v2/redux/actions/client'

export class Period extends Component {
  static displayName = 'Period'

  static propTypes = {
    cart: PropTypes.any,
    hasDates: PropTypes.bool,
    useTimes: PropTypes.bool,
    timeFormat: PropTypes.any,
    locations: PropTypes.object,
    autoOpenedModal: PropTypes.bool,
    onAutoModal: PropTypes.func,
    open: PropTypes.bool,
    modalOpen: PropTypes.bool,
    togglePicker: PropTypes.func,
    t: PropTypes.func
  }

  componentDidUpdate = (prevProps) => {
    const { autoOpenedModal, onAutoModal, hasDates, open, modalOpen } = this.props

    if (!autoOpenedModal && !prevProps.open && open && !hasDates && !modalOpen) {
      onAutoModal(() => {
        this.props.togglePicker(true)
      })
    }
  }

  handleOpenModal = () => {
    this.props.togglePicker(true)
  }

  render () {
    const { cart, locations, useTimes, hasDates, t } = this.props
    const hasLocations = locations.size() > 1

    return (
      <BPeriod data-tid="Select dates" className="bq-branded" onClick={this.handleOpenModal}>
        {hasDates ?
          (
            <BPeriod.WithDates className="bq-selected-dates">
              <BPeriod.Details>
                <BPeriod.Detail>
                  {hasLocations && (
                    <BPeriod.Location className="bq-branded">
          {cart && cart.start_location_id ? locations.getById(cart.start_location_id)?.name : null}
        </BPeriod.Location>
                  )}
                  <BPeriod.DateTime className="bq-branded">
                    {`${Format.date(
                      cart ? cart.starts_at : undefined,
                      'date'
                    )}${useTimes ?
                      `, ${Format.date(
                        cart ? cart.starts_at : undefined,
                        this.props.timeFormat
                      )}` :
                      ''}`}
                  </BPeriod.DateTime>
                </BPeriod.Detail>
                <Icon icon="arrow-right" />
                <BPeriod.Detail>
                  {hasLocations && (
                    <BPeriod.Location className="bq-branded">
          {cart && cart.stop_location_id ? locations.getById(cart.stop_location_id)?.name : null}
        </BPeriod.Location>
                  )}
                  <BPeriod.DateTime className="bq-branded">
                    {`${Format.date(
                      cart ? cart.stops_at : undefined,
                      'date'
                    )}${useTimes ?
                      `, ${Format.date(
                        cart ? cart.stops_at : undefined,
                        this.props.timeFormat
                      )}` :
                      ''}`}
                  </BPeriod.DateTime>
                </BPeriod.Detail>
              </BPeriod.Details>
              <Icon icon="sliders-v" />
            </BPeriod.WithDates>
          ) :
          (
            <BPeriod.NoDates className="bq-branded-border">
              <BPeriod.ChoosePeriod>{t('user.store.select_a_period')}</BPeriod.ChoosePeriod>
              <Icon icon="sliders-v" />
            </BPeriod.NoDates>
          )}
      </BPeriod>
    )
  }
}

const mapStateToProps = (state, props) => {
  let timeFormat

  if (state.settings.get('dates.use_am_pm')) {
    timeFormat = 'hh:mm A'
  } else {
    timeFormat = 'HH:mm'
  }

  return {
    locale: state.client.locale,
    timeFormat,
    useTimes: state.settings.get('store.use_times'),
    open: state.client.cartOpen,
    modalOpen: state.client.modalPickerOpen
  }
}

const mapDispatchToProps = (dispatch, props) => {
  return {
    togglePicker: ClientActions.toggleModalPicker
  }
}

const reduxComponent = reduxConnect(mapStateToProps, mapDispatchToProps)(Period)

export default withTranslation('user')(reduxComponent)
